export { default as AIcon } from './AIcon'
export { default as GrayAIcon } from './GrayAIcon'
export { default as NavyAIcon } from './NavyAIcon'
export { default as WhiteAIcon } from './WhiteAIcon'



// WEBPACK FOOTER //
// ./src/core/icons/AIcon/index.js